import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { BookOpen, ArrowRight } from "lucide-react";

export default function Library() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/articles").then((r) => { setItems(r.data); setLoading(false); }).catch(() => setLoading(false)); }, []);
  return (
    <div>
      <section className="bg-[var(--paper-2)] border-b border-[var(--line)]">
        <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 py-16">
          <div className="eyebrow">Research Library</div>
          <h1 className="h-display text-4xl md:text-6xl mt-2 leading-[1.04]">Reference reading.</h1>
          <p className="mt-3 max-w-2xl text-[var(--ink-soft)]">Scientific reference articles focused on analytical methods, COA interpretation, and laboratory storage practice. Not human-use guidance.</p>
        </div>
      </section>
      <section className="max-w-screen-2xl mx-auto px-4 sm:px-6 py-12">
        {loading && <div className="font-mono text-xs uppercase tracking-[0.2em] text-[var(--ink-muted)]">Loading…</div>}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((a) => (
            <Link key={a.slug} to={`/library/${a.slug}`} className="group border border-[var(--line)] bg-[var(--paper-2)] rounded-md p-6 hover:border-[var(--ink)] transition-colors" data-testid={`article-card-${a.slug}`}>
              <BookOpen className="h-5 w-5 text-[var(--terra)]" strokeWidth={1.6} />
              <div className="font-mono text-[10.5px] tracking-[0.18em] uppercase text-[var(--ink-muted)] mt-3">{a.category}</div>
              <div className="mt-2 font-display text-xl font-medium leading-tight group-hover:text-[var(--terra)] transition-colors">{a.title}</div>
              <p className="mt-3 text-sm text-[var(--ink-soft)] leading-relaxed">{a.summary}</p>
              <div className="mt-4 inline-flex items-center gap-1 text-xs font-mono uppercase tracking-wider text-[var(--ink)]">Read <ArrowRight className="h-3.5 w-3.5" /></div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
